initFlensFinder();

function initFlensFinder() {
	const container = document.querySelector('[data-flensfinder-container]');
	if (!container) {
		return;
	}

	/** Filter */
	const filterButton = container.querySelector('[data-filter-button]');
	const filterContainer = container.querySelector(
		'[data-filter-result-container]',
	);

	if (filterButton) {
		filterButton.addEventListener('click', () => {
			filterButton.classList.toggle('filter--is-open');
			filterContainer.classList.toggle('filter--is-open');
		});
	}

	/**
	 * load more
	 */
	initFlensFinderLoadMore(container);

	/** Close popup */
	const popupClose = container.querySelector('[data-popup-close]');
	popupClose?.addEventListener('click', () => {
		const popupContainer = container.querySelector('[data-popup-container]');
		popupContainer.classList.add('results-popup--is-remove');
		setTimeout(() => popupContainer.remove(), 250);
	});
}

function initFlensFinderLoadMore(container) {
	const button = container.querySelector('[data-load-more-button]');
	if (button) {
		button.addEventListener('click', () => onLoadMore(container, button));
	}
}

async function onLoadMore(container, button) {
	const resultList = container.querySelector('[data-load-more-result-list]');
	const loadingElement = container.querySelector('[data-load-more-image]');
	const errorElement = container.querySelector('[data-load-error]');
	const urlElement = container.querySelector('[data-load-more-url]');

	button.classList.add('hidden');
	errorElement.classList.add('hidden');
	loadingElement.classList.remove('hidden');

	try {
		const response = await fetch(urlElement.value);
		const { more = false, html = '' } = await response.json();
		resultList.innerHTML += html;
		button.classList.toggle('hidden', !more);
	} catch (error) {
		console.info('Flensfinder JSON File not available.');
		console.error(error);
		errorElement.classList.remove('hidden');
	}

	loadingElement.classList.add('hidden');
}
